import { createActions, createReducer } from 'reduxsauce'

import DetalhesEmpenhoService from '../../servicos/DetalhesEmpenhoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaValoresEmpenhoInicio: [],
    buscaValoresEmpenhoSucesso: ['valoresEmpenho'],
    buscaValoresEmpenhoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    resultado: [],
    selecionado: null,
    dataAtualizacaoDados: null,
}

// Ação para busca completa
Creators.buscaValoresEmpenho = filtro => {
    return dispatch => {
        dispatch(Creators.buscaValoresEmpenhoInicio())
        let serv = new DetalhesEmpenhoService()
        return serv
            .consultarValoresEmpenho(filtro)
            .then(response => dispatch(Creators.buscaValoresEmpenhoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaValoresEmpenhoErro(error)))
    }
}

const buscaValoresEmpenhoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaValoresEmpenhoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaValoresEmpenhoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, resultado: action.valoresEmpenho, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_VALORES_EMPENHO_INICIO]: buscaValoresEmpenhoInicio,
    [Types.BUSCA_VALORES_EMPENHO_ERRO]: buscaValoresEmpenhoErro,
    [Types.BUSCA_VALORES_EMPENHO_SUCESSO]: buscaValoresEmpenhoSucesso,
})
